import { render, staticRenderFns } from "./candidatePublicityEdit.vue?vue&type=template&id=27a08c0c&scoped=true"
import script from "./candidatePublicityEdit.vue?vue&type=script&lang=js"
export * from "./candidatePublicityEdit.vue?vue&type=script&lang=js"
import style0 from "./candidatePublicityEdit.vue?vue&type=style&index=0&id=27a08c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a08c0c",
  null
  
)

export default component.exports